var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hero-image-component" }, [
    _c("div", { staticClass: "hero-image-wrapper" }, [
      _c("h1", [_vm._v("“" + _vm._s(_vm.$t("homePage.testimonial")) + "”")]),
      _c("div", { staticClass: "image-container" }, [
        _vm._m(0),
        _c("div", { staticClass: "hero-name" }, [_vm._v("Jo Debecker")]),
        _c("div", { staticClass: "hero-title" }, [
          _vm._v(_vm._s(_vm.$t("homePage.president")))
        ])
      ]),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image-wrapper" }, [
      _c("img", {
        attrs: {
          src: require("@/drc/assets/images/people/jo-debecker.webp"),
          alt: "hero-image"
        }
      })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hero-image-animation" }, [
      _c("img", {
        attrs: {
          src: require("@/drc/assets/gifs/hero-image-animation.gif"),
          alt: "hero-image-animation"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }